import React from "react";
import "./BridalGallery.css";

function BridalGallery(props) {
  const { className } = props;

  return (
    <div className={`bridal-gallery border-1px-sonic-silver ${className || ""}`}>
      <div className="bridal-makeup-6 poppins-medium-tundora-10px">BRIDAL MAKEUP</div>
    </div>
  );
}

export default BridalGallery;
